import { on } from 'delegated-events'

const fn = {
  init: () => {
    on('change', '.wish-list-selector select', fn.handleWishList)
  },

  handleWishList: (e) => {
    const pageHeaderLeadIn = document.querySelector('.page-header .page-header-lead-in')
    const pageHeaderImage = document.querySelector('.page-header .page-header-image img')

    const wishList = document.querySelector(`[data-wish-list-url="${e.target.value}"]`)

    if (wishList) {
      const data = JSON.parse(wishList.dataset.wishList)

      if (pageHeaderLeadIn) {
        pageHeaderLeadIn.innerHTML = data.HeaderLeadIn
      }

      if (pageHeaderImage) {
        const newImage = document.createRange().createContextualFragment(data.HeaderImage)
        pageHeaderImage.parentNode.replaceChild(newImage, pageHeaderImage)
      }

      document.querySelectorAll('.wish-list-block').forEach((el) => el.classList.add('hidden'))
      wishList.classList.remove('hidden')

      const queryParams = new URLSearchParams(window.location.search)
      queryParams.set('list', wishList.dataset.wishListUrl)
      window.history.replaceState(null, null, `?${queryParams.toString()}`)
    }
  },
}

export default {
  can: () => document.body.classList.contains('pagetype-wishlistpage'),
  run: fn.init,
}
